import css from 'styled-jsx/css';

import { colorHighlight, sansSerif, serif } from 'styles/css-constants';

export default css`
  .Gallery--unzipped {
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    padding: 1rem 0;
  }

  .Gallery--unzipped :global(.Gallery__slide) {
    position: relative;
    margin-bottom: 1rem;
  }

  .Gallery--unzipped header {
    border: none;
    background-color: transparent;
    margin-bottom: 2em;
  }

  .Gallery--unzipped :global(.Gallery__show-more) {
    display: block;
    border: none;
    padding: 0.5rem;
    background-color: ${colorHighlight};
    color: #fff;
    font-family: ${sansSerif};
    font-size: 14px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .Gallery--unzipped :global(.Gallery__show-more-message::before) {
    content: 'Expand Gallery';
  }

  .Gallery--unzipped
    :global(section[expanded])
    :global(.Gallery__show-more-message::before) {
    content: 'Collapse Gallery';
  }

  .Gallery--unzipped :global(.Gallery__slide-position) {
    padding: 0.5rem;
    border: 2px solid #000;
    color: #000;
    margin: 0.5em;
    position: absolute;
    z-index: 1;
    background: white;
    font-family: ${serif};
    font-weight: bold;
  }

  .Gallery--unzipped :global(.ImageCaption:not(:empty)) {
    padding: 0 0 1rem 0;
    font-family: ${serif};
    line-height: 1.55;
  }

  .Gallery--unzipped :global(section) {
    display: flex;
    flex-direction: column;
  }

  .Gallery--unzipped .Gallery__ad {
    margin: 1rem auto 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
    width: 300px;
  }

  .Gallery--unzipped .Gallery__ad::before {
    content: 'Advertisement';
    display: block;
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: #ddd;
    text-align: center;
    font-family: ${sansSerif};
    font-size: 12px;
    border-bottom: 1px solid #ddd;
  }

  .Gallery--unzipped .Gallery__ad :global(amp-ad) {
    display: block;
  }
`;
